export default __webpack_public_path__ + "static/media/card4.13aa13df.png";